import {Box, Flex} from '@chakra-ui/react';
import {colors, useCartContext} from 'components/providers';
import {useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {IOrder} from 'types';

import {ActiveOrders, GlobalCart} from './components';

interface IProps {
  ordersActive: IOrder[];
  orders: IOrder[];
  onHandlerSetLimit: () => void;
  isDesktop: boolean;
  isLoadingOrders: boolean;
  isFromHomePage?: boolean;
}

export const BottomStatusBar: FC<IProps> = ({
  isDesktop,
  orders,
  onHandlerSetLimit,
  ordersActive,
  isLoadingOrders,
  isFromHomePage,
}) => {
  const {
    cartItems,
    cartItemsPrice,
    requiredProducts,
    deliveryDetails,
    dynamicDeliveryPrice,
    setSideCartOpen,
    cartProvider,
  } = useCartContext();
  const {t} = useTranslation();
  const {push, pathname} = useRouter();
  const isMainPage = pathname === '/';
  const {surcharge, surcharge_for_out_area} = dynamicDeliveryPrice;
  const totalPrice = cartItemsPrice + (deliveryDetails?.deliveryAmount ?? 0) + surcharge_for_out_area + surcharge;
  const requiredProductsCount = !!requiredProducts.length;
  const isMetro = cartProvider?.slug === 'metro';
  const isMetroRoute = pathname.startsWith('/categories/') || pathname.startsWith('/metro');

  const countItemProduct = cartItems.reduce((sum, currentItem) => {
    if (isMetro) {
      return sum + (currentItem.product.is_weighted_product ? 1 : Number(currentItem.quantity));
    }
    return sum + Number(currentItem.quantity);
  }, 0);

  const countCartWithRequiredProducts = countItemProduct + requiredProducts.length;
  const count = requiredProductsCount ? countCartWithRequiredProducts : countItemProduct;

  if (cartItems.length === 0 && ordersActive.length === 0) return null;

  const onClickHandler = () => {
    if (ordersActive.length === 0) {
      if (isDesktop) return setSideCartOpen(true);
      push('/cart');
    }
  };
  const onClickHandlerFromProvider = () => {
    if (isDesktop) return setSideCartOpen(true);
    push('/cart');
  };

  return (
    <Flex w="full" justifyContent="center" alignItems="center">
      <Box
        w={['90%', '40%']}
        borderRadius="20px"
        bg={colors.pink}
        cursor="pointer"
        color={colors.white}
        position="fixed"
        bottom={isDesktop ? '2' : isFromHomePage ? '65px' : 2}
        zIndex={cartProvider?.slug === 'metro' || isMetroRoute ? 'banner' : 'overlay'}
        onClick={onClickHandler}
      >
        <Flex justifyContent="space-between" alignItems="center" py={['5px', '10px']} px={['30px', '60px']}>
          {(isMainPage && ordersActive.length > 0) || count === 0 ? (
            <ActiveOrders
              orders={orders}
              onHandlerSetLimit={onHandlerSetLimit}
              isLoadingOrders={isLoadingOrders}
              ordersActive={ordersActive}
              t={t}
            />
          ) : (
            <GlobalCart
              price={totalPrice}
              t={t}
              count={countCartWithRequiredProducts}
              isDesktop={isDesktop}
              onClick={onClickHandlerFromProvider}
              isMetro={isMetro}
            />
          )}
        </Flex>
      </Box>
    </Flex>
  );
};
